import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import ValidationController from '../../controller/ValidationController';
import SalesOrderAPI from '../../api/SalesOrderAPI';
import Const from '../../util/Constants';
import Util from '../../util/Util';
import FieldDate from '../common/FieldDate';
import FieldDecimal from '../common/FieldDecimal';
import FieldSelect from '../common/FieldSelect';
import FieldText from '../common/FieldText';
import InstallmentCustom from "./InstallmentCustom";

class InstallmentPopUp extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).installment;

    this.installment = {
      id: 0, model_no: props.sale.model_no, model_id: props.sale.model_id,
      sales_order_id: props.sale.id, installment_date: Util.dateToServerDateTime(new Date()),
      amount: 0, mode: 0, account: 0, installment_status: 0, comment: ''
    };
    if (props.installment) { 
      this.installment = { ...props.installment };
    }
    this.state = { inApiCall: true, inValid: {}, installment: { ...this.installment } };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.sale.id !== this.installment.sales_order_id) {
      this.installment.sales_order_id = props.sale.id;
      this.installment.model_no = props.sale.model_no;
      this.installment.model_id = props.sale.model_id;
    }
    if (props && props.installment && props.installment.id !== this.state.installment.id) {
      this.setState({ ...this.state, installment: { ...props.installment } });
    } else if (props.installment === null) {
      this.setState({ ...this.state, installment: { ...this.installment } });
    }
  }

  onChange = (field, value) => {
    const installment = { ...this.state.installment };
    installment[field] = value;
    this.setState({ ...this.state, inValid: {}, installment: { ...installment } });
  };

  save = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.installment);
    if (inValid === null) {
      this.setState({ ...this.state, popup: false, inApiCall: true });
      SalesOrderAPI.saveInstallment(this.state.installment, this.success, this.onFail);
    } else {
      Util.showNotification('Form incomplete', 'Please fill all information', 'danger');
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  success = () => {
    this.props.hide();
    Util.showNotification('Successful', 'Installment Addes successfully', 'success');
    this.props.reload();
  };

  render() {
    const fields = this.model.fields;
    const installment = this.state.installment;
    return (
      <Modal show={this.props.show} onHide={this.props.hide}
        size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Installment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="row-cols-2 colmr">
              <FieldText key="installment_receipt" id="installment_receipt"
                field={fields.installment_receipt} value={installment.installment_receipt}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <FieldDate key="installment_date" id="installment_date"
                field={fields.installment_date} value={installment.installment_date}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <FieldDecimal key="amount" id="amount"
                field={fields.amount} value={installment.amount}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <FieldSelect key="mode" id="mode"
                field={fields.mode} value={installment.mode}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <FieldSelect key="account" id="account"
                field={fields.account} value={installment.account}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <FieldSelect key="installment_status" id="installment_status"
                field={fields.installment_status} value={installment.installment_status}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <FieldText key="comment" id="comment"
                field={fields.comment} value={installment.comment}
                onValueChange={this.onChange} inValid={this.state.inValid} />
              <InstallmentCustom model={this.model} call={installment} onValueChange={this.onChange}
                inValid={this.state.inValid} />
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer> <Button onClick={this.save}>Save</Button></Modal.Footer>
      </Modal>
    );
  }
}
export default InstallmentPopUp;